import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CSVLink } from 'react-csv';
import { parse } from 'json2csv';
import { DownloadOutlined } from '@ant-design/icons';

import { columnsToCSVFields } from 'utils/table';

import './style.css';

const DownloadTable = ({ data, columns, name }) => {
  const csv = parse(data, { fields: columnsToCSVFields(columns) });
  return (
    <CSVLink data={csv} filename={`my-shift-${name}.csv`}>
      <Button type="primary" icon={<DownloadOutlined />} size="small">
        Download
      </Button>
    </CSVLink>
  );
};

DownloadTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
};

export default DownloadTable;
